// extracted by mini-css-extract-plugin
export default {"settingsItem":"SettingsItem_settingsItem__PGerl","description":"SettingsItem_description__+P+XY","title":"SettingsItem_title__UPVcl"};